/**
 * @generated SignedSource<<3dc47ff94ccb21423d50acc628337735>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoOverviewListItemMediumDescription_Todo$data = {
  readonly files: ReadonlyArray<{
    readonly __typename: "File";
  }>;
  readonly images: ReadonlyArray<{
    readonly __typename: "Image";
  }>;
  readonly isIssue: boolean;
  readonly subject: {
    readonly " $fragmentSpreads": FragmentRefs<"TodoSubjectExcludeRoot_TodoSubject" | "TodoSubject_TodoSubject">;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "TodoOverviewListItemMediumDescription_Todo";
};
export type TodoOverviewListItemMediumDescription_Todo$key = {
  readonly " $data"?: TodoOverviewListItemMediumDescription_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemMediumDescription_Todo">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoOverviewListItemMediumDescription_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isIssue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubject",
      "kind": "LinkedField",
      "name": "subject",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoSubject_TodoSubject"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoSubjectExcludeRoot_TodoSubject"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "929e3767dd0b129d1236aa1c8eeb74eb";

export default node;
